import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer, { drawerClasses } from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import MenuContent from './MenuContent';
import { useUser } from '../../lib/auth-client';
import { authClient } from '../../lib/auth-client';
import { FacultyFilter } from '../Filters';

interface SideMenuMobileProps {
	open: boolean | undefined;
	toggleDrawer: (newOpen: boolean) => () => void;
}

export default function SideMenuMobile({ open, toggleDrawer }: SideMenuMobileProps) {
	const { user } = useUser();

	const handleLogout = async () => {
		try {
			await authClient.signOut();
			// Better Auth handles session cleanup automatically
		} catch (error) {
			console.error('Logout error:', error);
			// Force redirect to login even if API call fails
			window.location.href = '/login';
		}
		toggleDrawer(false)();
	};

	return (
		<Drawer
			anchor="right"
			open={open}
			onClose={toggleDrawer(false)}
			sx={{
				zIndex: (theme) => theme.zIndex.drawer + 1,
				[`& .${drawerClasses.paper}`]: {
					backgroundImage: 'none',
					backgroundColor: 'background.paper',
				},
			}}
		>
			<Stack
				sx={{
					maxWidth: '70dvw',
					height: '100%',
				}}
			>
				<Stack direction="row" sx={{ p: 2, pb: 0, gap: 1 }}>
					<Stack
						direction="row"
						sx={{ gap: 1, alignItems: 'center', flexGrow: 1, p: 1 }}
					>
						<Avatar
							sizes="small"
							alt={user?.name || 'User'}
							sx={{ width: 24, height: 24, bgcolor: 'primary.main' }}
						>
							{user?.name?.charAt(0).toUpperCase() || 'U'}
						</Avatar>
						<Stack>
							<Typography component="p" variant="body2" fontWeight="medium">
								{user?.name || 'Unknown User'}
							</Typography>
							<Typography variant="caption" color="text.secondary">
								{user?.role === 'admin' ? 'Quản trị viên' : 'Người dùng'}
							</Typography>
						</Stack>
					</Stack>
				</Stack>
				<Divider />
				<FacultyFilter />
				<Divider />
				<Stack sx={{ flexGrow: 1 }}>
					<MenuContent onNavigate={toggleDrawer(false)} />
				</Stack>
				<Stack sx={{ p: 2 }}>
					<Button
						variant="outlined"
						fullWidth
						startIcon={<LogoutRoundedIcon />}
						onClick={handleLogout}
					>
						Đăng xuất
					</Button>
				</Stack>
			</Stack>
		</Drawer>
	);
}